import { callApi } from "../services/apiService";
import { responseHandler } from "../handler/responseHandler";
export const adminDashboardApi = {
  getCandidatesDetailsByPeriod: async (params = {}, signal = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_details",
      params: params,
      signal: signal,
    });
    return responseHandler(response);
  },

  getallEntities: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/all_entities",
      params: params,
    });
    return responseHandler(response);
  },

  fetchEntityItems: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/fetch_entity_items",
      params: params,
    });
    return responseHandler(response);
  },

  fetchProjectPhaseActivity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/get_project_phase_activity",
      params: params,
    });
    return responseHandler(response);
  },

  fetchSubSector: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/get_subsectors",
      params: params,
    });
    return responseHandler(response);
  },
  getBroadbeanCandidates: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/broadbean_candidates",
      params: params,
    });
    return responseHandler(response);
  },
  addActivityEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_activity",
      params: params,
    });
    return responseHandler(response);
  },

  updateDeleteActivityEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_activity",
      params: params,
    });
    return responseHandler(response);
  },

  addCountryEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_country",
      params: params,
    });
    return responseHandler(response);
  },
  updateDeleteCountryEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_country",
      params: params,
    });
    return responseHandler(response);
  },

  addCvOriginEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_cv_origin",
      params: params,
    });
    return responseHandler(response);
  },

  updateCvOriginEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_cv_origin",
      params: params,
    });
    return responseHandler(response);
  },

  addEducationEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_education_level",
      params: params,
    });
    return responseHandler(response);
  },
  updateEducationEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_education_level",
      params: params,
    });
    return responseHandler(response);
  },
  addExperienceEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_experience",
      params: params,
    });
    return responseHandler(response);
  },
  updateExperienceEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_experience",
      params: params,
    });
    return responseHandler(response);
  },

  addLanguageEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_language",
      params: params,
    });
    return responseHandler(response);
  },

  updateLanguageEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_language",
      params: params,
    });
    return responseHandler(response);
  },

  addLanguageLevelEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_language_level",
      params: params,
    });
    return responseHandler(response);
  },

  updateLanguageLevelEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_language_level",
      params: params,
    });
    return responseHandler(response);
  },

  addProjectPhaseEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_project_phase",
      params: params,
    });
    return responseHandler(response);
  },

  updateProjectPhaseEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_project_phase",
      params: params,
    });
    return responseHandler(response);
  },

  addSectorEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_sector",
      params: params,
    });
    return responseHandler(response);
  },

  updateSectorEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_sector",
      params: params,
    });
    return responseHandler(response);
  },

  addSubSectorEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_subsector",
      params: params,
    });
    return responseHandler(response);
  },

  updateSubSectorEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_subsector",
      params: params,
    });
    return responseHandler(response);
  },

  addMobyStatusEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_moby_status",
      params: params,
    });
    return responseHandler(response);
  },
  updateMobyStatusEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_moby_status",
      params: params,
    });
    return responseHandler(response);
  },

  addProjectPhaseActivity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_project_phase_activity",
      params: params,
    });
    return responseHandler(response);
  },

    updateProjectPhaseActivity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_project_phase_activity",
      params: params,
    });
    return responseHandler(response);
  },

  addServiceTypeEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/add_service_type",
      params: params,
    });
    return responseHandler(response);
  },

  updateServiceTypeEntity: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/update_service_type",
      params: params,
    });
    return responseHandler(response);
  },

  // admin Dashboard
  fetchTotalCandidates: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/total_candidates",
      params: params,
    });
    return responseHandler(response);
  },

  fetchTotalVacancies: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/total_vacancies",
      params: params,
    });
    return responseHandler(response);
  },

    fetchSectorWiseChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/sector_wise_placements",
      params: params,
    });
    return responseHandler(response);
  },

  fetchActiveRecruiteres: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/total_recruiters",
      params: params,
    });
    return responseHandler(response);
  },

  fetchRecruiterActivityChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/recruiter_activity",
      params: params,
    });
    return responseHandler(response);
  },
  fetchCandidateFunnelChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_funnel",
      params: params,
    });
    return responseHandler(response);
  },
  fetchSectorWiseCandidates: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/sector_wise_candidates",
      params: params,
    });
    return responseHandler(response);
  },
  fetchSectorWiseVacancies: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/sector_wise_vacancies",
      params: params,
    });
    return responseHandler(response);
  },
  fetchCVOriginsChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/cv_origin",
      params: params,
    });
    return responseHandler(response);
  },

  fetchRecruiterLeaderboardChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/recruiter_leaderboard",
      params: params,
    });
    return responseHandler(response);
  },

  genderChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_gender_distribution",
      params: params,
    });
    return responseHandler(response);
  },

    hitRateChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/hit_rate_report",
      params: params,
    });
    return responseHandler(response);
  },
  nationalityChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_nationalities",
      params: params,
    });
    return responseHandler(response);
  },
  jobLocationsChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/job_locations",
      params: params,
    });
    return responseHandler(response);
  },
  ageChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_age_distribution",
      params: params,
    });
    return responseHandler(response);
  },
  locationChart: async (params = {}) => {
    const response = callApi({
      method: "POST",
      endpoint: "admin/candidate_locations",
      params: params,
    });
    return responseHandler(response);
  },
};
